import React, { useEffect, useRef } from 'react';

import { useGlobalState } from '../GlobalState';
import { Col } from 'antd';
import moment from 'moment';
import SvgTimer from '../../assets/images/Timer';
import SelectTimeControl from '../../../common/SelectTimeControl';

export default function SelectTime({ fishery_id, loading }) {
  const [arrivalTime, setArrivalTime] = useGlobalState('arrivalTime');
  const [departureTime, setDepartureTime] = useGlobalState('departureTime');
  const [isArrivalFixed, setIsArrivalFixed] = useGlobalState('isArrivalFixed');
  const [isDepartureFixed, setIsDepartureFixed] =
    useGlobalState('isDepartureFixed');
  const [availableTime] = useGlobalState('availableTime');
  const [bookingDates] = useGlobalState('bookingDates');
  const [lakeDetails] = useGlobalState('lakeDetails');

  const sectionRef = useRef();

  const is24HourLakeWithNoDeparture = Boolean(
    lakeDetails?.is_24_hour_lake &&
      moment(bookingDates?.[0]?.endDate).isSame(
        bookingDates?.[0]?.startDate,
        'day'
      )
  );

  /* Prevents showing arrival dates for 24 hour lakes if no departure is selected */
  const hasValidDeparture =
    moment(bookingDates?.[0]?.endDate).isValid() &&
    !is24HourLakeWithNoDeparture;

  const hasSelectedDates =
    Boolean(bookingDates?.[0]?.startDate) && hasValidDeparture;

  useEffect(() => {
    if (loading || !hasValidDeparture || !sectionRef?.current) {
      return;
    }
    if (
      moment(bookingDates?.[0]?.startDate).isSame(
        bookingDates?.[0]?.endDate,
        'day'
      )
    ) {
      return;
    }
    sectionRef.current.scrollIntoView({
      block: 'start',
      inline: 'nearest',
      smooth: true,
    });
  }, [bookingDates, hasValidDeparture, loading]);
  useEffect(() => {
    if (availableTime?.arrival?.length === 1) {
      setArrivalTime(availableTime?.arrival?.[0]?.arrival_ts);
    }
    if (availableTime?.departure?.length === 1) {
      setDepartureTime(availableTime?.departure?.[0]?.departure_ts);
    }
  }, [availableTime]);

  useEffect(() => {
    if (arrivalTime && availableTime?.arrival) {
      let arrivalOptionSelected = availableTime?.arrival?.filter(
        (item) => item.arrival_ts === arrivalTime
      );
      if (
        arrivalOptionSelected[0]?.hour == 'Dawn' ||
        arrivalOptionSelected[0]?.hour == 'Dusk'
      ) {
        setIsArrivalFixed(arrivalOptionSelected[0]?.hour);
      } else {
        setIsArrivalFixed(null);
      }
    } else {
      setIsArrivalFixed(null);
    }
    if (departureTime && availableTime?.departure) {
      let departureOptionSelected = availableTime?.departure?.filter(
        (item) => item.departure_ts === departureTime
      );

      if (
        departureOptionSelected[0]?.hour == 'Dawn' ||
        departureOptionSelected[0]?.hour == 'Dusk'
      ) {
        setIsDepartureFixed(departureOptionSelected[0]?.hour);
      } else {
        setIsDepartureFixed(null);
      }
    } else {
      setIsDepartureFixed(null);
    }
  }, [arrivalTime, departureTime]);
  const arrivalDate =
    availableTime?.arrival?.[0]?.arrival_ts ?? bookingDates?.[0]?.startDate;
  const departureDate =
    availableTime?.departure?.[0]?.departure_ts ?? bookingDates?.[0]?.endDate;

  return (
    <Col
      style={{ width: '100%', opacity: loading || !hasSelectedDates ? 0.2 : 1 }}
    >
      <div
        ref={sectionRef}
        className='booking-time-heading mg-top-8 mg-bottom-8'
      >
        <SvgTimer className={'fs-20'} />
        <span>Step 2: Select Times</span>
      </div>
      <div className={'mg-top-30 mg-bottom-30'}>
        {hasSelectedDates ? (
          <SelectTimeControl
            loading={loading}
            fisheryPublicId={fishery_id}
            availability={availableTime}
            selectedLakeId={lakeDetails?.lake_id}
            arrivalTime={arrivalTime}
            onChangeArrival={setArrivalTime}
            departureTime={departureTime}
            onChangeDeparture={setDepartureTime}
            arrivalDate={arrivalDate}
            departureDate={departureDate}
          />
        ) : (
          <div className={'w-full txt-center fs-15 gRegular black'}>
            Available Times Will Load After Selecting Dates
          </div>
        )}
      </div>
    </Col>
  );
}
